import { render } from "./DatabaseCard.vue?vue&type=template&id=30ebc5b1"
import script from "./DatabaseCard.vue?vue&type=script&lang=js"
export * from "./DatabaseCard.vue?vue&type=script&lang=js"
script.render = render

export default script